import { EDITAR_ROTA } from "constants/ActionTypes";

const INIT_STATE = {
    rotasSelecionadas: [],
    rotaEdit: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case EDITAR_ROTA: {
            return {
                ...state,
                rotaEdicao: action.payload.data,
                rotaEdit: true,
            };
        }

        default:
            return state;
    }
};
